import { getApiViolations } from "src/utils/apiViolations";
import type { WizardStepKey } from "./useWizardStepsV2";
import type { SectionErrors } from "./validation";

const LINE_VIOLATION_PATH = /^(productIngredients|productPackagings)(?:\[(\d+)\]|\.(\d+))\.(ingredient|packaging)$/;

const SECTION_BY_COLLECTION: Record<string, WizardStepKey> = {
    productIngredients: "recipe",
    productPackagings: "packaging",
};

export const productViolationsToSectionErrors = (error: unknown): SectionErrors => {
    const sectionErrors: SectionErrors = {};

    for (const violation of getApiViolations(error) ?? []) {
        const match = LINE_VIOLATION_PATH.exec(violation.propertyPath ?? "");
        if (match === null) continue;

        const [, collection, bracketIndex, dotIndex, item] = match;
        const section = SECTION_BY_COLLECTION[collection];
        (sectionErrors[section] ??= []).push({
            field: `${collection}.${bracketIndex ?? dotIndex}.${item}`,
            messageKey: "form.invalid_field",
            message: violation.message,
        });
    }

    return sectionErrors;
};

export const mergeSectionErrors = (...sources: SectionErrors[]): SectionErrors => {
    const merged: SectionErrors = {};

    for (const source of sources) {
        for (const [section, errors] of Object.entries(source) as [
            WizardStepKey,
            NonNullable<SectionErrors[WizardStepKey]>,
        ][]) {
            merged[section] = [...(merged[section] ?? []), ...errors];
        }
    }

    return merged;
};
